<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品价格表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.projectcode" placeholder="请选择" class="select" filterable>
              <el-option
                v-for="item in ProjectNameList" :key="item.Code" :label="item.Name" :value="item.Code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickexcel()">导出Excel</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel" ></TencentyunCosUploadExcel>
            注意：此处是覆盖导入
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border :cell-style="{padding: '0'}">
          <el-table-column prop="Projectname" label="产品名称" width="220"></el-table-column>
          <el-table-column prop="Projectcode" label="产品编码" width="150"></el-table-column>
          <el-table-column prop="Unit" label="单位" width="50"></el-table-column>
          <el-table-column prop="Chengbenjia" label="成本价" width="80"></el-table-column>
          <el-table-column prop="Jituanneibucaigoujia" label="集团内部采购价" width="120"></el-table-column>
          <el-table-column prop="Yujingxianjia" label="预警限价" width="80"></el-table-column>
          <el-table-column prop="Yujingxianjiazhekou" label="预警限价折扣率" width="120"></el-table-column>
          <el-table-column prop="Yujingxianjiaqiding" label="预警限价起订量" width="120"></el-table-column>
          <el-table-column prop="Yujingxianjiaquanxian" label="预警限价权限" width="120"></el-table-column>
          <el-table-column prop="Tiepaijia" label="贴牌价" width="80"></el-table-column>
          <el-table-column prop="Tiepaijiazhekou" label="贴牌价折扣率" width="120"></el-table-column>
          <el-table-column prop="Tiepaijiaqiding" label="贴牌起订量" width="100"></el-table-column>
          <el-table-column prop="Xiaoyu5xianjia" label="数量小于5限价" width="120"></el-table-column>
          <el-table-column prop="Xiaoyu5xianjiazhekou" label="数量小于5限价折扣率" width="160"></el-table-column>
          <el-table-column prop="Shichangjia" label="市场销售价" width="100"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" width="200"></el-table-column>
          <el-table-column prop="operation" label="操作" width="200" fixed="right">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加产品价格" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm" label="产品名称">
          <el-select v-model="addForm.projectcode" placeholder="请选择" class="select" filterable>
            <el-option
              v-for="item in ProjectNameList" :key="item.Code" :label="item.Name" :value="item.Code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="计量单位">
          <el-input v-model="addForm.unit"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="成本价">
          <el-input v-model="addForm.chengbenjia"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="集团内部采购价">
          <el-input v-model="addForm.jituanneibucaigoujia"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="预警限价">
          <el-input v-model="addForm.yujingxianjia"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="预警限价折扣率">
          <el-input v-model="addForm.yujingxianjiazhekou"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="预警限价起订量">
          <el-input v-model="addForm.yujingxianjiaqiding"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="预警限价权限">
          <el-input v-model="addForm.yujingxianjiaquanxian"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="贴牌价">
          <el-input v-model="addForm.tiepaijia"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="贴牌价折扣率">
          <el-input v-model="addForm.tiepaijiazhekou"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="贴牌起订量">
          <el-input v-model="addForm.tiepaijiaqiding"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="数量小于5限价">
          <el-input v-model="addForm.xiaoyu5xianjia"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="数量小于5限价折扣率">
          <el-input v-model="addForm.xiaoyu5xianjiazhekou"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="市场销售价">
          <el-input v-model="addForm.shichangjia"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <el-tab-pane label="修改" name="three" disabled="disabled">
      <Erp6SaleBaseProductPriceEdit ref="SubVuethree" v-on:triggerFunc="BackToFirst"></Erp6SaleBaseProductPriceEdit>
    </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import Erp6SaleBaseProductPriceEdit from '@/componentsSubVue/Erp6SaleBaseProductPriceEdit.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel,
    Erp6SaleBaseProductPriceEdit
  },
  name: 'MyErp6SaleBaseProductPrice',
  data () {
    return {
      activeName: 'first',
      ProjectNameList:[],
      addForm: {
        projectcode: '',
        unit: '',
        chengbenjia: '',
        jituanneibucaigoujia: '',
        yujingxianjia: '',
        yujingxianjiazhekou: '',
        yujingxianjiaqiding: '',
        yujingxianjiaquanxian: '',
        tiepaijia: '',
        tiepaijiazhekou: '',
        tiepaijiaqiding: '',
        xiaoyu5xianjia: '',
        xiaoyu5xianjiazhekou: '',
        shichangjia: ''
      },
      // 查询
      keywords: {
        projectcode: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetErp6SaleBaseProductPriceNum()
    this.apiGetErp6SaleBaseProductPriceList()

    this.apiGetErp6ProjectNameList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp6SaleBaseProductPriceList()
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportErp6SaleBaseProductPrice(url)
    },
    clickexcel () {
      this.apiExcelErp6SaleBaseProductPrice()
    },
    clickadd () {
      this.apiAddErp6SaleBaseProductPrice()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiJiGou(row.Id)
      })
    },
    clickEdit (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    clickDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelErp6SaleBaseProductPrice(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetErp6SaleBaseProductPriceNum()
      this.apiGetErp6SaleBaseProductPriceList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6SaleBaseProductPriceList()
    },
    //为下拉框获取数据源-项目名称
    apiGetErp6ProjectNameList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: '',
        code: '',
        classification: ''
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6ProjectNameList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.ProjectNameList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetErp6SaleBaseProductPriceNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        projectcode: that.keywords.projectcode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseProductPriceNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6SaleBaseProductPriceList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        projectcode: that.keywords.projectcode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseProductPriceList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp6SaleBaseProductPrice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.addForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp6SaleBaseProductPrice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SaleBaseProductPriceNum()
            that.apiGetErp6SaleBaseProductPriceList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelErp6SaleBaseProductPrice: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelErp6SaleBaseProductPrice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SaleBaseProductPriceNum()
            that.apiGetErp6SaleBaseProductPriceList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelErp6SaleBaseProductPrice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        projectcode: that.keywords.projectcode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelErp6SaleBaseProductPrice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImportErp6SaleBaseProductPrice: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportErp6SaleBaseProductPrice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetErp6ProjectNameList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}
.select1{
    width: 113px;
    margin-right: 15px;
}
/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
/deep/ .el-table .cell {
  white-space: pre-line;
}
</style>
